import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-full flex flex-col items-center justify-center text-center p-8 bg-white dark:bg-zinc-950">
          <p className="text-xs tracking-[0.2em] uppercase font-mono text-gray-500 dark:text-gray-400 mb-2">
            Noget gik galt
          </p>
          <p className="text-[10px] font-mono text-gray-400">
            Genindlæs siden for at prøve igen
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
